/**
 * Route for `pentest`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PentestPage } from "../features/pentest/PentestPage";

export const pentestRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/pentest",
	component: PentestPage,
});

export default pentestRoute;
